import React from 'react';

import {Helmet, useParams} from 'views/module';

import CaseViewScene from 'views/scenes/case/detail/CaseView';

const CaseView = (props) => {
  const params = useParams();
  const caseRn = params.caseRn;

  return (
    <>
      <Helmet>
        <title>Quilt: Case Details</title>
      </Helmet>
      <CaseViewScene caseRn={caseRn} />
    </>
  );
};

export default CaseView;
